import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// TYPES
import { RichTextType } from '../../libs/types';

export interface PropsType {
	content: RichTextType;
	className?: string;
	characterLimit?: number;
}

const RichText: React.FC<PropsType> = ({ content, className = '' }) => {
	const navigate = useNavigate();

	const el = useRef<HTMLDivElement>(null);
	const text = content?.markup;

	function handleClick(e: Event) {
		const { href, target } = e.target as HTMLAnchorElement;

		if (href) {
			// Handle media links - open in new tab
			if (href.includes('/media/')) {
				e.preventDefault();
				window.open(href, '_blank');
				return;
			}

			const isExternal = href?.includes('://') && !href?.includes(window.location.host);

			if (!isExternal && target !== '_blank') {
				e.preventDefault();

				// Check if href is already a full URL (internal)
				if (href.startsWith('http://') || href.startsWith('https://')) {
					// Extract just the path from the full internal URL
					const url = new URL(href);
					navigate(url.pathname + url.search + url.hash);
				} else {
					// Handle relative paths
					const internalPath = href.startsWith('/') ? href : `/${href}`;
					navigate(internalPath);
				}
			}
		}
	}

	const initialiseAnchors = () => {
		const parentEl = el.current;
		if (!parentEl) return;

		const anchors = parentEl.querySelectorAll('a[href]');
		for (const anchor of anchors) anchor.addEventListener('click', handleClick);

		return () => {
			for (const anchor of anchors) anchor.removeEventListener('click', handleClick);
		};
	};

	useEffect(() => {
		return initialiseAnchors();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	if (text) {
		return <div ref={el} className={`wysiwyg-content ${className}`} dangerouslySetInnerHTML={{ __html: text }}></div>;
	}

	return null;
};

export default RichText;
